import * as model from '../data/model'
import * as dal from '../data/dal'
import Credits from 'src/views/credits/Credits';
import * as track from '../data/track/track';
export interface IState {
  languageName: string;
  lo_ctx: LoadingObject<dal.Context>;
  lo_PodCasts:LoadingObject<Array<model.PodCast>>;
  lo_Tracks:LoadingObject<Array<model.Track>>;
  lo_CustomerBalance:LoadingObject<model.CustomerBalance>;
  viewState: ViewState;
  dispatch: any;
  errorState:ErrorState;
  isLoggedIn:boolean;
}
class ErrorState
{
  showError:boolean;
  errorArray: Array<track.ErrorObj> = new Array<track.ErrorObj>();
  lastError: track.ErrorObj;
}
export enum LoadingState {
  NotLoaded,
  Loading,
  Completed,
  Error
}
export class LoadingObject<T> {
  loadingState: LoadingState = LoadingState.NotLoaded;
  notLoaded():boolean
  {
     return this.loadingState == LoadingState.NotLoaded
  }
  loading():boolean
  {
     return this.loadingState == LoadingState.Loading;
  }
  completed():boolean{
    return this.loadingState == LoadingState.Completed;
  }
  error():boolean{
    return this.loadingState == LoadingState.Error;
  }
  errorMessage: string;
  value?:T
  val():T
  {
    //@ts-ignore
    return this.value
  }
  setLoading(){
      this.loadingState = LoadingState.Loading;
  };
  setCompleted(value:T){
    this.loadingState = LoadingState.Completed;
    this.value = value;
  }
  setError(err:any){
    this.loadingState = LoadingState.Error;
  }
  reset()
  {
    this.loadingState = LoadingState.NotLoaded;
    this.value = undefined;
  }

  constructor(value?: T) {
    if (value) {
      this.value = value;
    }
  }
}
export function getDefaultState() {
  let defaultState: IState = {
    languageName: "en",
    viewState: new ViewState(),
    errorState:new ErrorState(),
    lo_ctx: new LoadingObject<dal.Context>(),
    lo_PodCasts: new LoadingObject<Array<model.PodCast>>(),
    lo_Tracks: new LoadingObject<Array<model.Track>>(),
    lo_CustomerBalance : new LoadingObject<model.CustomerBalance>(),
    dispatch: null,
    isLoggedIn:false
  };
  return defaultState;
}
export enum AppSection {
  LogIn = "/pages/login",
  LogOut = "/pages/logout",
  LoggingIn = "/pages/loggingin",
  Feeds = "/feeds",
  NewTrack = "/views/tracks/new",
  TrackValidate = '/views/tracks/validate',
  PodCast = '/views/podcasts',
  Credits = '/views/credits',
  Plan = '/views/plan',
  Discovery = '/views/discovery'
}
export class ViewState {
  appSection: AppSection;
  redirect: any;
  static navigate(url:string)
  {
  
    window['hist'].push(url)
   // window.location.pathname =hash;//.hash=hash;
  }
  static getDefaultHash(appSection: AppSection): string {
    return appSection.toString();
  }
  static hashTrackCreate(podcastId:any):string{
    return ViewState.getDefaultHash(AppSection.NewTrack)+'?podcast_id='+podcastId
  }
  static hashPodCastEdit(id:any):string{
    return ViewState.getDefaultHash(AppSection.PodCast)+'/'+id+'/edit';
  }
  static hashPodCastView(id:any):string{
    return ViewState.getDefaultHash(AppSection.PodCast)+'/'+id;
  }
  static hashPodCastList():string{
    return ViewState.getDefaultHash(AppSection.PodCast);
  }
  static hashTrackValidate(id:any){
    return ViewState.getDefaultHash(AppSection.TrackValidate)+'/'+id;
  }
  /*
  static viewStateFromRoute(match: any): ViewState {
    var vs = new ViewState();
    vs.appSection = AppSection.Tracks;
    for (var enumMember in AppSection) {
      var isValueProperty = parseInt(enumMember, 10) >= 0;
      if (isValueProperty) {
        if (AppSection[enumMember] == match.path) {
          let typed = enumMember as keyof typeof AppSection;
          vs.appSection = AppSection[typed];
        }
      }
    }
    vs.redirect = match.params.redirect ? match.params.redirect : "";
    return vs;
  }*/
  deepCopy(): ViewState {
    var newState = new ViewState();
    var v: any = this;
    for (var i in v) {
      newState[i] = v[i];
    }
    return newState;
  }
  
  getHash(): string {
    switch (this.appSection) {
      case AppSection.Feeds:
      case AppSection.NewTrack:
      case AppSection.Discovery:
        return ViewState.getDefaultHash(this.appSection);
      case AppSection.LogIn:
        return this.redirect
          ? ViewState.getDefaultHash(this.appSection) +
              "?redirect=" +
              this.redirect
          : ViewState.getDefaultHash(this.appSection);
      default:
        return ViewState.getDefaultHash(AppSection.PodCast);
    }
  }
}



export class FrontEndProfileProvider implements dal.IProfileProvider
{
  authenticate(email: string, password: string): Promise<string>
  {
     return new Promise<string>((resolve,reject)=>{
       reject('not implemented');
     });
  }
  setToken(token: string): Promise<model.Profile>{
    return new Promise<model.Profile>((resolve,reject)=>{
      reject('not implemented');
    });
  }
  authenticateWithGoogle(googleToken: string): Promise<string>
  {
    return new Promise<string>((resolve,reject)=>{
      reject('not implemented');
    });
  }
 
  getProfile(): model.Profile {
    if(!window["profile"])
      throw "no profile found"
    return window["profile"] as model.Profile;
   
  }
}




// WEBPACK FOOTER //
// ./src/types/istate.ts